import { useMemo } from 'react';

import { useGetRecentComment } from '~hooks/query/jobdom/useRecentComment';

import LoadingItem from './LoadingItem';
import RecentCommentItem from './RecentCommentItem';
import * as S from './style';

export default function RecentComment() {
  const { data, status } = useGetRecentComment();
  const recentCommentData = useMemo(() => {
    if (status !== 'success') {
      return [];
    }

    return data.data.slice(0, 3);
  }, [data, status]);

  return (
    <S.RecentCommentWrapper>
      <S.RecentCommentHead>새로운 JOB담</S.RecentCommentHead>
      <S.RecentCommentList>
        {status === 'loading' ? (
          <>
            <LoadingItem />
            <LoadingItem />
            <LoadingItem />
          </>
        ) : (
          <>
            {recentCommentData.map((comment) => (
              <RecentCommentItem {...comment} key={`recent_comment_${comment.id}`} />
            ))}
          </>
        )}
      </S.RecentCommentList>
    </S.RecentCommentWrapper>
  );
}
